// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zFYTJ","rootMobile":"styles_rootMobile__2Imv1"};